import { AutoCompleteMulti, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useEffect } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import RadioGroupInput from "../../../../../../components/RadioGroup/RadioGroupInput";
import MainApi from "../../../../../../services/mainApi.service";
import { workspacesList } from "../../../../../../services/ticketWorkspace.service";
import {
  isChannelRestrictionType,
  isWorkspaceRestrictionType,
  TICKET_DEFAULT_DOC_RESTRICTION_TYPE,
} from "./TicketDefaultDocRestrictionType";

const translationPath = "page.settings.crm.protocolsDefault.";

const TICKET_CHANNEL_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketChannels/";
const ticketChannelService = new MainApi(TICKET_CHANNEL_ROUTE);

const TicketDefaultDocRestrictionFields = () => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext();

  const restrictionType = useWatch({
    name: "restrictionType",
    control,
  });

  useEffect(() => {
    if (isWorkspaceRestrictionType(restrictionType)) {
      setValue("ticketChannels", []);
    }
    if (isChannelRestrictionType(restrictionType)) {
      setValue("ticketWorkspaces", []);
    }
  }, [restrictionType, setValue]);

  return (
    <>
      <Grid item xs={12} sm={12}>
        <RadioGroupInput
          name="restrictionType"
          groupLabel={t(translationPath + "restriction_type")}
          optionsContainerSx={{
            justifyContent: "flex-start",
            columnGap: 3,
            rowGap: 1,
          }}
          radios={[
            {
              label: t(translationPath + "workspace"),
              value: TICKET_DEFAULT_DOC_RESTRICTION_TYPE.WORKSPACE,
            },
            {
              label: t(translationPath + "restriction_type_board"),
              value: TICKET_DEFAULT_DOC_RESTRICTION_TYPE.CHANNEL,
            },
          ]}
        />
      </Grid>

      {isWorkspaceRestrictionType(restrictionType) && (
        <Grid item xs={12} sm={6}>
          <AutoCompleteMulti
            name="ticketWorkspaces"
            label={t(translationPath + "workspaces")}
            size="small"
            request={workspacesList}
          />
        </Grid>
      )}

      {isChannelRestrictionType(restrictionType) && (
        <Grid item xs={12} sm={6}>
          <AutoCompleteMulti
            name="ticketChannels"
            label={t(translationPath + "channels")}
            size="small"
            request={ticketChannelService.list}
          />
        </Grid>
      )}
    </>
  );
};

export default memo(TicketDefaultDocRestrictionFields);
